<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
// 套件
import axios from 'axios'
import moment from 'moment'
// 資料
import Service from './assets/js/data/Service.js'
import APIConfig from './assets/js/data/remote/APIConfig.js'
require('./assets/css/index.js')

export default {
  methods: {
    initAxios () {
      const exceptURLs = [
        APIConfig.BPIURL + '/login',
        APIConfig.BPIURL + '/refresh'
      ]
      const isExcept = url => {
        return url.includes('/api') || exceptURLs.indexOf(url) >= 0
      }

      axios.interceptors.request.use(config => {
        if (isExcept(config.url)) return config

        let jwt = config.headers['Authorization'].split('.')
        let exp = JSON.parse(atob(jwt[1])).exp

        config.headers['Content-Encoding'] = 'gzip'

        let isNewToken = Math.floor(Date.now() / 1000) < exp - 300
        if (isNewToken) return config

        return this.$services.auth.refresh(this).then(token => {
          config.headers['Authorization'] = `Bearer ${token}`
          return config
        })
      })

      // axios.interceptors.response.use(null, error => {
      // })
    }
  },
  created () {
    moment.locale('zh-tw')
    Vue.prototype.$services = Service.shared
    this.initAxios()

    const handleServiceError = err => {
      console.error(`handleServiceError error`, err)
      var msg = err
      if (err instanceof Error && err.response && err.response.data) {
        msg = err.response.data.error
      }
      this.$alert(msg, '錯誤', {
        confirmButtonText: 'ok',
        type: 'error'
      })
    }
    Vue.prototype.$handleServiceError = handleServiceError

    let jwt = this.$services.auth.getJWT()
    if (jwt) {
      axios.defaults.headers['Authorization'] = `Bearer ${jwt}`
    }

    if (this.$route.name !== 'launch') {
      this.$router.push({ name: 'launch' })
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
